<div class="flex flex-col min-h-screen pt-20 pl-10 pr-10 overflow-y-auto landing-background-image">
  <div class="grid main-content">
    <div class="col-span-4 lg:col-span-5 md:col-span-12 sm:col-span-12 landing-width">
      <div class="text-left">
        <h1 class="text-6xl font-bold text-white uppercase line-height-title">The place for bringing owners & contractors</h1>
        <h1 class="text-6xl font-bold text-green-200 uppercase line-height-title">together!</h1>
      </div>
      <div class="w-4/5 pt-10 pb-10">
        <p class="text-2xl text-white">Your opportunity for public works contracts begins with your no obligation free registration</p>
      </div>
      <div class="mt-3">
        <div class="flex-row space-x-4 xs:flex-col">
          <button class="text-lg text-white rounded landing-button outline-3" (click)="signUp()">Sign Up</button>
          <button class="text-lg text-white rounded landing-button" routerLink="/login">Log In</button>
          <button class="text-lg text-white rounded landing-button" routerLink="/opportunities">Opportunities</button>
        </div>
      </div>
    </div>
  </div>

  <div class="flex footer">
    <ul>
      <li><img src="../../assets/colbi-white.png" alt="Colbi Technologies Inc." style="height: 1.5rem" /></li>
      <li>Copyright 2025&copy; by Colbi Technologies Inc.&trade;</li>
      <li>All Right Reserved</li>
      <li><a href="/privacy-policy" target="_blank">Privacy Policy</a></li>
      <li><a href="/release-of-liability" target="_blank">Release of Liability</a></li>
      <li><a href="mailto:qbsupport@colbitech.com" _target="blank">Help</a></li>
    </ul>
  </div>
</div>
